import axios from '../../../axios-marketplace';

const cancelar = (idCompra, data) => axios.put(`/fornecedor/compras/${idCompra}/recusar`, data);

export default {
  cancelar,
};
